import React, { useEffect, useState } from "react";
import { GeoAlt, Map } from "react-bootstrap-icons";
import { HiLocationMarker } from "react-icons/hi";
import { GrMapLocation } from "react-icons/gr";
import { getParkingLocationsAPI } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import { Loader } from "../common/Loader";

const LocationSection = ({ onSelectLocation, selectedLocation, setSelectedLocation, isExtendParking, extendBookingData }) => {

  const [parkingLocations, setParkingLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  // ----------------PARKING LOCATIONS LIST----------------------
  const fetchParkingLocations = async () => {
    setLoading(true);
    try {
      const res = await getParkingLocationsAPI();
      if (res?.status) {
        setParkingLocations(res?.data || []);
      }
      else {
        errorAlert({ message: res?.message || "Something went wrong." });
      }
    }
    catch (err) {
      errorAlert({message: err?.response?.data?.message || err?.message || "Something went wrong." });
    }
    finally {
      setLoading(false)
    }
  }




  // ----------------HANDLE SELECT LOCATION--------------------
  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
    onSelectLocation(location)
  }


  // ------HANDLE OPEN LOCATION IN GOOGLE MAP--------------------
  const openMap = (url) => {
    window.open(url, "_blank");
  };

  // ----------------EFFECTS----------------------
  useEffect(() => {
    fetchParkingLocations();
  }, []);

  useEffect(() => {
    if (isExtendParking) {
      const loc = parkingLocations.find((loc) => loc?._id === extendBookingData?.location);
      console.log("5------------------",loc);
      if (loc) { setSelectedLocation(loc); }
    }
  }, [isExtendParking, parkingLocations])


  return (<>
    <Loader show={loading} />
     {!isExtendParking && 
    <section className="card">
      <h4> <HiLocationMarker size={30} color="#2563eb" /> Select Location</h4>
      <p className="sub-text">Choose a yard or parking location</p>

        <div className="location-grid">
        {parkingLocations.map((loc, i) => {
          const isDisabled = loc?.avaliableSlots <= 0;
          return (
            <div
              key={loc?._id}
              onClick={() => { if (!isDisabled) { handleLocationSelect(loc); } }}
              className={`location-card ${selectedLocation?._id === loc?._id ? "active" : ""} ${isDisabled ? "bg-light disabled" : ""} `}
            >
              {/* TOP */}
              <div className="top">
                {loc.recommended && (
                  <span className="badge">Recommended</span>
                )}

                <span className="map" onClick={(e) => { e.stopPropagation(); openMap(loc?.locationUrl) }}>
                  <GrMapLocation size={14} /> View Map
                </span>
              </div>

              {/* TITLE */}
              <h5>{loc?.locationName}</h5>

              {/* ADDRESS */}
              <p className="address">
                {loc?.locationAddress}

              </p>

              {/* BOTTOM */}
              <div className="bottom">
                <div className="spots-box">
                  <GeoAlt size={16} />
                  <div>
                    <strong>{loc?.avaliableSlots > 0 ? loc?.avaliableSlots : 0}</strong>
                    <small> Spots Left</small>
                  </div>
                </div>

                <div className="price">
                  ${loc?.location_price[0]?.monthlySubscriptionPrice?.overridePrice || 0}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>}
  </>);
}

export default React.memo(LocationSection);